export default __webpack_public_path__ + "static/media/tip.a8750f67.svg";